import { useState, useEffect } from 'react';
import { Box, FormControlLabel, Paper, Radio, RadioGroup, Typography, useMediaQuery } from '@mui/material';
import { useAppContext } from '../context/AppContext';

const ProductFilters = () => {
  const { setRows, originalRows } = useAppContext();

  const [variantFilter, setVariantFilter] = useState('all');

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  // Apply filter based on current variantFilter value
  const applyFilter = (filterValue, rowsToFilter) => {
    if (filterValue === 'onlySent') {
      const updRows = rowsToFilter.filter((row) => row.color_status !== 'red');
      setRows(updRows);
    } else if (filterValue === 'noneSent') {
      const updRows = rowsToFilter.filter((row) => row.color_status === 'red');
      setRows(updRows);
    } else {
      setRows(rowsToFilter);
    }
  };

  // Reapply filter whenever originalRows changes (e.g., after saving in modal)
  useEffect(() => {
    if (originalRows.length > 0) {
      applyFilter(variantFilter, originalRows);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalRows]);

  const handleFilterChange = (e) => {
    const { value } = e.target;
    setVariantFilter(value);
    applyFilter(value, originalRows);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        width: '90%',
        mb: 2,
      }}
    >
      <Paper
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 2,
          boxShadow: '0px 0px 6.3px 0px #00000026',
          borderRadius: 1,
          ...(isMobile && {
            flexDirection: 'column',
            flexBasis: '100%',
            py: 1,
            gap: 0,
          }),
        }}
      >
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          Filter by variant status:
        </Typography>
        <RadioGroup row value={variantFilter} onChange={handleFilterChange}>
          <FormControlLabel value="all" control={<Radio />} label="All" />
          <FormControlLabel value="onlySent" control={<Radio />} label="Only sent" />
          <FormControlLabel value="noneSent" control={<Radio />} label="None sent" />
        </RadioGroup>
      </Paper>
    </Box>
  );
};

export default ProductFilters;
